var module = angular.module('components');
module.component('caContactInfo', {
    templateUrl: 'components/genericcomponents/contactinfo.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        contactInfo: '=',
        isEditing: '<',
        removeContactInfo: '&'
    },
    controller: [contactInfoController]
});

function contactInfoController() {
    var vm = this;

    vm.remove = remove;

    function remove() {
        vm.removeContactInfo();
    }
}
